"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthenticationContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _login = require("../actions/login");
var _authentication = require("../actions/authentication");
var _tabs = require("../actions/tabs");
var _state = require("../actions/state");
var _view = require("../actions/view");
var _loadMROAuth = require("../../browser/utils/loadMROAuth");
var _initMROAuth = require("./initMROAuth");
var _registration = require("../actions/registration");
var _source = require("../actions/source");
class AuthenticationContext {
  constructor(store, emitter) {
    (0, _defineProperty2.default)(this, "store", void 0);
    (0, _defineProperty2.default)(this, "emitter", void 0);
    this.store = store;
    this.emitter = emitter;
  }
  get state() {
    return this.store.getState();
  }
  set state(state) {
    this.store.dispatch((0, _state.setState)(state));
  }
  setTab(tab) {
    this.store.dispatch((0, _tabs.changeTab)(tab));
  }
  setView(view, data) {
    this.store.dispatch((0, _view.changeView)(view, data));
  }
  setSource(source) {
    this.store.dispatch((0, _source.changeSource)(source));
  }
  resetAuthentication() {
    this.store.dispatch((0, _authentication.reset)());
  }
  setAuthenticationLogin(login) {
    this.store.dispatch((0, _login.changeLogin)(login));
  }
  setRegistrationParams(params) {
    this.store.dispatch((0, _registration.professionalUserChange)(params.isProfessionalUser));
  }
  showMROAuthOneTap() {
    return (0, _loadMROAuth.loadMROAuth)().then(MR => {
      MR.logout();
      (0, _initMROAuth.initMROAuth)({
        authClient: MR,
        store: this.store,
        eventEmitter: this.emitter
      });
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  on(type, handler) {
    this.emitter.addListener(type, handler);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  off(type, handler) {
    this.emitter.removeListener(type, handler);
  }
}
exports.AuthenticationContext = AuthenticationContext;